// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.0001 2H6.00005V4H18.0001V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.0001 5H4.00005V7H20.0001V5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.1612 8H1.83887L3.93887 22H20.0612L22.1612 8ZM15.1667 15L10.5 18.5V11.5L15.1667 15Z"}}]};

const VideoLibraryFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'video-library-filled',
    ref,
    icon: element,
  },
));

VideoLibraryFilledIcon.displayName = 'VideoLibraryFilledIcon';

export default VideoLibraryFilledIcon;
